import { render, staticRenderFns } from "./CompanySettingsProfile.vue?vue&type=template&id=63f7d8c6&scoped=true"
import script from "./CompanySettingsProfile.vue?vue&type=script&lang=js"
export * from "./CompanySettingsProfile.vue?vue&type=script&lang=js"
import style0 from "./CompanySettingsProfile.vue?vue&type=style&index=0&id=63f7d8c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f7d8c6",
  null
  
)

export default component.exports